<template>
  <div class="ruKuZuoyeWarp-body app-container">
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="80px">
        <div class="formItemBox">
        <el-form-item label="一级货主:">
          <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:">
          <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货物类型:">
          <el-select v-model="formData.productType" size="mini" placeholder="请选择货物类型" filterable clearable
            @change="productTypeChange">
            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
              :value="item.productType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地:">
          <el-select v-model="formData.steelMillName" size="mini" placeholder="请选择产地" filterable clearable
            @change="steelMillNameChange">
            <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格:">
          <el-select v-model="formData.specification" size="mini" placeholder="请选择规格" filterable clearable
            @change="specificationChange">
            <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材质:">
          <el-select v-model="formData.model" size="mini" placeholder="请选择材质" filterable clearable
            @change="modelChange">
            <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="件数:">
          <el-select v-model="formData.number" size="mini" placeholder="请选择件数" filterable clearable>
            <el-option v-for="(item, index) in numberOptions" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
       </div>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP004B001" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP004B002" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="preSelectList" btnCode="00ZP004B003"
            v-if="btnFlg[2]&&chaoqiFlag==false">预选清单
          </el-button>
          <el-button type="primary" size="mini" @click="clear" btnCode="00ZP004B004" v-if="btnFlg[3]">盘盈盘亏</el-button>
          <el-button type="primary" size="mini" @click="exportClick" btnCode="00ZP004B005" v-if="btnFlg[4]">导出
          </el-button>
          <el-button type="primary" size="mini" @click="daoru" btnCode="00ZP004B006" v-if="btnFlg[5]">导入</el-button>
          <el-button type="primary" size="mini" @click="modelDown" btnCode="00ZP004B007" v-if="btnFlg[6]">下载模版
          </el-button>
          <el-button type="primary" size="mini" @click="jiagongFn" btnCode="00ZP004B007" v-if="btnFlg[9]">加工
          </el-button>
          <el-button type="primary" size="mini" @click="kctzFn" btnCode="00ZP004B007" v-if="btnFlg[10]">库存调整
          </el-button>
          <!-- 黄骅港库20250321 -->
          <el-button type="primary" size="mini" @click="pypkFn"  v-if="btnFlg[11]">盘盈盘亏</el-button>
        </el-form-item>
        <el-form-item>
           <span>
            总吨数:
            <span style="color: red">{{Number(totalAllWeight)}}</span> &nbsp;吨
          </span>
          <span style="margin-left: 15px">
            总件数:
            <span style="color: red">{{ totalNumber }}</span> &nbsp;件
          </span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
        style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        highlight-current-row @row-click="dianjixuanzhong" @selection-change="selectGoods">
        <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column fixed width="100" label="操作" align="center" v-if="chaoqiFlag==false">
          <template v-slot='scope'>
            <el-button type="text" @click="quXiaoYuZhuan(scope.$index,scope.row)" v-if="scope.row.isYuanZhuanFlag">取消预转
            </el-button>
            <el-button type="text" @click="PreSelect(scope.$index,scope.row)" v-else>预转</el-button>

          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
          width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" width="120"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <!-- 转货弹框 -->
    <el-dialog title="预选清单" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="turnMark"
      @close="closeDialog" width="80%" center>
      <div v-loading='turnLoading'>
        <div class="bigBox">
          <div>
            <el-button type="primary" @click="clearArr">清空</el-button>
            <p style="display:inline-block;margin-left:10px;">
              <span>转货总重量：<span class="numbers" style="color:red;">{{changeAllWeight}}</span>吨</span>
              <span style="margin-left:20px;" v-if="turnGoodsTableList.length>0&&turnGoodsTableList[0].isEnable==1">未提量：
                <span v-if="turnGoodsTableList.length>0&&turnGoodsTableList[0].controlWeight==1"><span class='numbers'
                    style="color:red;">{{turnGoodsTableList[0].controlStockWeight}}</span>吨</span>
                <span
                  v-if="turnGoodsTableList.length>0&&turnGoodsTableList[0].controlPiece==1">{{turnGoodsTableList[0].controlWeight==1?'/':''}}<span
                    class='numbers' style="color:red;">{{turnGoodsTableList[0].controlStockNumber}}</span>件</span>
              </span>
              <span style="margin-left:20px;" v-if="turnGoodsTableList.length>0&&turnGoodsTableList[0].isEnable==1">库存量：
                <span v-if="turnGoodsTableList.length>0"><span class='numbers'
                    style="color:red;">{{turnGoodsTableList[0].KucunAllWeight}}</span>吨</span>
                <span v-if="turnGoodsTableList.length>0">/<span class='numbers'
                    style="color:red;">{{turnGoodsTableList[0].KucunAllNumber}}</span>件</span>
              </span>
            </p>
            <el-table :data="turnGoodsTableList" ref="turnGoodsTableList" border bordersize="mini"
              style="width: 100%;margin-top:10px;" center :header-cell-style="{background:'#F5F5F5',color:'black'}"
              :header-row-style="{height:'45px'}" :row-style="{height:'35px'}" highlight-current-row>
              <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
              <el-table-column type="text" width="55" label="操作" align="center">
                <template slot-scope="scope2">
                  <el-button @click="delClick(scope2.$index, scope2.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="" label="件数" align="center" width="150">
                <template slot-scope="scope">
                  <div>
                    <el-input placeholder="请输入件数" @input="numContro($event,scope.row)" v-number-input.float="0"
                      maxlength="100" v-model="scope.row.changeNumber" size="mini" style="width:100px;"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="重量（吨）" align="center" width="150">
                <template slot-scope="scope">
                  <div>
                    <el-input placeholder="" @input="numControB($event,scope.row)" v-number-input.float="4"
                      maxlength="100" v-model="scope.row.changeWeight" size="mini" style="width:100px;"
                      :disabled='scope.row.outWeighingMethod==1'></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="stockAvailableNumber" label="库存可提件数" align="center" width="120"></el-table-column>
              <!-- <el-table-column prop="" label="货权剩余" align="center" width="150" ></el-table-column> -->
              <el-table-column prop="productTypeName" label="货物类型" align="center" width="100"></el-table-column>
              <el-table-column prop="steelMillName" label="产地" align="center" width="100"></el-table-column>
              <el-table-column prop="specification" label="规格" width="130" align="center"></el-table-column>
              <el-table-column prop="model" label="材质" align="center" width="100"></el-table-column>
              <el-table-column prop="number" label="件数" align="center" width="100"></el-table-column>
              <el-table-column prop="allWeight" label="总重量（吨）" align="center" width="120"></el-table-column>
              <el-table-column prop="weight" label="理重（吨）" align="center" width="120"></el-table-column>
              <el-table-column prop="stockPoundWeight" label="过磅净重（吨）" align="center" width="120"></el-table-column>
              <el-table-column prop="primaryCustomerName" label="一级货主" align="center" width="230"></el-table-column>
              <el-table-column prop="customerName" label="二级货主" align="center" width="230"></el-table-column>

            </el-table>
          </div>
          <!--  表格 -->
          <div style="margin:10px 0 10px 0 ;">
            <div style="color:red;">注：默认重量（吨）=单件理重（吨）*件数</div>
          </div>
        </div>
        <div slot="footer" style="width:300px;margin:15px auto;">
          <el-button @click="changeResetForm" size='mini'>取 消</el-button>
          <el-button btnCode="00ZM0C0200" v-if="turnGoodsTableList[0]&&turnGoodsTableList[0].isEnable == 1&&btnFlg[8]" type="primary"
            @click="zhuanhuoSubmit('hg')" size='mini'>回 购</el-button>
          <el-button btnCode="00ZM0C0100" v-if="turnGoodsTableList[0]&&turnGoodsTableList[0].isEnable == 2 &&btnFlg[7]" type="primary"
            @click="zhuanhuoSubmit('gczh')" size='mini'>钢厂转货</el-button>
          <el-button type="primary" @click="zhuanhuoSubmit('zh')" size='mini'>转 货</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <daoru v-if="daoruMark" :daoruMark.sync="daoruMark"></daoru>
    <!-- 转货申请1 -->
    <el-dialog width="80%" :title="trunTitle" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="turnZhuanhuo" @close="zhuanhuoDialogclose" center>
      <el-form :inline="true" :model="turnform" class="demo-form-inline" ref="turnform">
        <el-form-item label="转货后一级货主:" :rules="[{required:true,message:'请选择转货后一级货主',trigger:'change'}]">
          <el-select :disabled='trunFlag=="huigou"' v-model="turnform.primaryCustomerTaxId" size="mini"
            placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转货后二级货主:" :rules="[{required:true,message:'请选择转货后二级货主',trigger:'change'}]">
          <el-select v-model="turnform.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left:10px;" v-if="showBianhao" label="货主转货单编号:"
          :rules="[{required:false,message:'请输入货主转货单编号',trigger:'blur'}]">
          <el-input style="width:172px;" v-model.trim="turnform.customerChangNo" maxlength="50" size="mini"
            placeholder="请输入货主转货单编号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="width:150px;margin:15px auto;">
        <el-button @click="zhuanhuoDialogclose" size='mini'>取 消</el-button>
        <el-button type="primary" @click="zhuanhuoSave" :loading='ZhuanhuoLoading' size='mini'>保 存</el-button>
      </div>
    </el-dialog>
    <!-- 转货申请2 建材结算-->

    <app-lication v-if="applyVisible" :applyVisible.sync="applyVisible" :isReminder='isReminder' @sendmsg="getmsg"
      :oneAndTwo1=danjiaList :oneAndTwo=turnGoodsTableList :RKData=RKData>
    </app-lication>
    <!-- 强提醒？ -->
    <el-dialog title="提示" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="ReminderVisible"
      @close="ReminderCancel" center>
      <div class='messages'>{{message}}</div>
      <div slot="footer" style="width:200px;margin:15px auto;">
        <el-button @click="ReminderCancel" size='mini'>取 消</el-button>
        <el-button type="primary" @click="ReminderOk" size='mini'>确定并继续</el-button>
      </div>
    </el-dialog>
    <!-- 加工 -->
     <jiagong v-if="jiagongFlag" :jiagongFlag.sync="jiagongFlag" :rowData="xuanzhongArr"></jiagong>
     <!-- 库存调整 -->
     <kucuntiaozheng v-if="kctzFlag" :kctzFlag.sync="kctzFlag" :rowData="xuanzhongArr"></kucuntiaozheng>
  </div>

</template>

<script>
import {
  getRelationCustomer,
  getVirtualBalingList,
  JfgetCustomerAvailableNumber,
  getWeighingMethodList,
  JfgetStockCustomerList,
  JfgetStockCustomerWN,
  JfclearStockCustomer,
  JfvirtualControlBean,
  JfaddEmptyChangeExp,
  zidian,
  getDictionaryJson,
  JfgetCustomerStock,
  clearStockCustomerCoal
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getBtn
} from '@/utils/getButton'
import daoru from './daoru.vue'
import AppLication from './application.vue'
import jiagong from './jiagong.vue'
import kucuntiaozheng from './kucuntiaozheng.vue'
const Debounce = (fn, t) => {
  let delay = t || 500
  let timer
  return function () {
    let context = this
    let args = arguments

    if (timer) clearTimeout(timer)

    let callNow = !timer
    timer = setTimeout(() => {
      timer = null
    }, delay)

    if (callNow) fn.apply(context, args)
  }
  // return function () {
  //   let args = arguments
  //   if (timer) {
  //     clearTimeout(timer)
  //   }
  //   timer = setTimeout(() => {
  //     timer = null
  //     fn.apply(this, args)
  //   }, delay)
  // }
}

export default {
  components: {
    daoru,
    AppLication,
    jiagong,
    kucuntiaozheng
  },
  name: 'kehuKucun',
  data () {
    return {
      showBianhao: false,
      oneAndTwo: [],
      danjiaList: [],
      turnform: {
        primaryCustomerTaxId: '',
        customerTaxId: '',
        customerChangNo: ''
      },
      formData: {
        primaryCustomerTaxId: '',
        customerTaxId: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        number: ''
      },
      RKData: [],
      productTypeData: [],
      steelMillNameData: [],
      specificationData: [],
      modelData: [],
      numberOptions: [{
        value: '',
        label: '全部'
      }, {
        value: '0',
        label: '0'
      }, {
        value: '-1',
        label: '不为0'
      }],
      totalAllWeight: 0,
      totalNumber: 0,
      h: '500px',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      turnGoodsTableList: [],
      turnMark: false,
      applyVisible: false,
      turnLoading: false,
      residue: 0,
      changeAllWeight: 0,
      daoruMark: false,
      selectListId: [],
      selectList: [],
      trunTitle: '转货申请',
      turnZhuanhuo: false,
      chaoqiFlag: false,
      trunFlag: 'zhuanhuo',
      ZhuanhuoLoading: false,
      btnArr: [
        '00ZP004B001',
        '00ZP004B002',
        '00ZP004B003',
        '00ZP004B004',
        '00ZP004B005',
        '00ZP004B006',
        '00ZP004B007',
        '00ZM0C0100',
        '00ZM0C0200',
        '00ZM0C0300', '00ZM0C0400', '00ZM0C0500'
      ],
      btnFlg: [],
      xuanzhongArr: null,
      ReminderVisible: false,
      message: '',
      isReminder: 0,
      jiagongFlag: false,
      kctzFlag: false
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 170 + 'px'
    this.getRelationCustomerS()
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/clientInventory')
    this.getVirtualBalingList()
    this.JfgetStockCustomerLists()
    getDictionaryJson({
      groupNo: 'jc_overdue_settlement_flag',
      itemNo: localStorage.getItem('tenantCode')
    })
      .then(res => {
        // 是否配置超期费，配置了则不显示预转+清单
        if (res.length !== 0) {
          this.chaoqiFlag = true
        } else {
          this.chaoqiFlag = false
        }
      })
      .catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  methods: {
    // 黄骅港盘盈盘亏
    pypkFn () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
        return
      }
      this.$confirm('盘盈盘亏不可恢复，确定清零吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        clearStockCustomerCoal({
          stockCustomerId: this.xuanzhongArr.stockCustomerId // 主键id
        }).then((res) => {
          this.$message.success('操作成功')
          this.JfgetStockCustomerLists()
        }).catch((err) => {
          this.$message.error(err.message)
        })
      }).catch(() => {})
    },
    // 库存调整
    kctzFn () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
        return
      }
      this.kctzFlag = true
    },
    // 加工
    jiagongFn () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
        return
      }
      this.jiagongFlag = true
    },
    getmsg () {
      this.turnGoodsTableList = []
      this.turnMark = false
      this.applyVisible = false
      this.ZhuanhuoLoading = false
      // this.oneAndTwo = []
      this.changeAllWeight = 0
      this.JfgetStockCustomerLists()
    },

    // 总数
    JfgetStockCustomerWNs () {
      JfgetStockCustomerWN({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        number: this.formData.number
      })
        .then(res => {
          this.totalAllWeight = res.totalWeight
          this.totalNumber = res.totalNumber
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 列表查询
    JfgetStockCustomerLists () {
      JfgetStockCustomerList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        number: this.formData.number
      })
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.turnGoodsTableList.forEach(item => {
            this.tableData.forEach((item1, index) => {
              if (!item1.isYuanZhuanFlag) {
                let a = item.stockCustomerId == item1.stockCustomerId
                item1.isYuanZhuanFlag = a
              }
            })
          })
          this.JfgetStockCustomerWNs()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.turnMark = false
      // this.turnGoodsTableList=[]
      this.JfgetStockCustomerLists()
    },
    chongzhi () {
      this.formData = {}
      this.chaxun()
      this.getVirtualBalingList()
    },
    quXiaoYuZhuan (index, row) {
      console.log(index, row)
      // row.isYuanZhuanFlag = false
      for (let a = 0; a < this.turnGoodsTableList.length; a++) {
        if (this.turnGoodsTableList[a].stockCustomerId == row.stockCustomerId) {
          this.turnGoodsTableList.splice(a, 1)
          this.$set(row, 'isYuanZhuanFlag', false)
        }
      }

      this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => {
        return pre / 1 + cur.changeWeight / 1
      }, 0)
    },
    // 点预转
    PreSelect: Debounce(function (index, row) {
      let hadselect = false
      this.turnGoodsTableList.forEach(item => {
        if (item.stockCustomerId == row.stockCustomerId) {
          hadselect = true
        }
      })
      if (this.turnGoodsTableList.length > 0 && (row.primaryCustomerTaxId != this.turnGoodsTableList[0]
        .primaryCustomerTaxId || row.customerTaxId != this.turnGoodsTableList[0].customerTaxId)) {
        this.$message({
          message: '一级货主二级货主必须相同',
          type: 'error'
        })
      } else if (hadselect) {
        this.$message({
          message: '不可重复选择',
          type: 'error'
        })
      } else {
        JfvirtualControlBean({
          oneCustomerTaxId: row.primaryCustomerTaxId,
          twoCustomerTaxId: row.customerTaxId,
          organizationId: window.localStorage.getItem('tenantCode'),
          productionPlaceName: row.steelMillName,
          specificationName: row.specification,
          materialName: row.model,
          goodTypeName: row.productTypeName
        })
          .then(res => {
            console.log(res)
            let jsonRes = JSON.parse(res)
            console.log(jsonRes)
            row.isEnable = jsonRes.isEnable
            row.controlPiece = jsonRes.controlPiece
            row.controlWeight = jsonRes.controlWeight
            row.controlStockWeight = jsonRes.controlStockWeight ? jsonRes.controlStockWeight : 0
            row.controlStockNumber = jsonRes.controlStockNumber ? jsonRes.controlStockNumber : 0
            row.strictReminder = jsonRes.strictReminder
            JfgetCustomerStock({
              primaryCustomerTaxId: row.primaryCustomerTaxId,
              customerTaxId: row.customerTaxId,
              productType: jsonRes.goodTypeName,
              steelMillName: jsonRes.productionPlaceName,
              specification: jsonRes.specificationName,
              model: jsonRes.materialName
            })
              .then(res => {
                console.log(res)
                row.KucunAllWeight = res.totalAllWeight
                row.KucunAllNumber = res.totalNumber
              })
              .catch(err => {
                this.$message({
                  message: err.message,
                  type: 'error'
                })
              })
            if (this.turnGoodsTableList.length == 0) {
              JfgetCustomerAvailableNumber({
                primaryCustomerTaxId: row.primaryCustomerTaxId,
                customerTaxId: row.customerTaxId,
                productType: row.productType,
                steelMillName: row.steelMillName,
                model: row.model,
                specification: row.specification,
                productTypeName: row.productTypeName
              })
                .then(res => {
                  row.stockAvailableNumber = res
                  this.$set(row, 'changeNumber', '')
                  this.$set(row, 'changeWeight', '')
                  this.$set(row, 'isYuanZhuanFlag', true)
                  getWeighingMethodList({
                    productType: row.productType
                  })
                    .then(res => {
                      console.log(res)
                      if (res.length > 0) row.outWeighingMethod = res[0].outWeighingMethod
                      row.RowStr = row.isEnable == 2 ? '不控货'
                        : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}${jsonRes.specificationName ? jsonRes.specificationName : ''}${jsonRes.materialName ? jsonRes.materialName : ''}` ==
                          '' ? '总控'
                          : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`
                      this.turnGoodsTableList.push(row)
                    })
                    .catch(err => {
                      this.$message({
                        message: err.message,
                        type: 'error'
                      })
                    })
                })
                .catch(err => {
                  this.$message({
                    message: err.message,
                    type: 'error'
                  })
                })
            } else {
              console.log(res)
              let Str =
                  `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`
              // let RowStr = `${this.turnGoodsTableList[0].steelMillName ? this.turnGoodsTableList[0].steelMillName : ''}${this.turnGoodsTableList[0].productTypeName ? this.turnGoodsTableList[0].productTypeName : ''}${this.turnGoodsTableList[0].specification ? this.turnGoodsTableList[0].specification : ''}${this.turnGoodsTableList[0].model ? this.turnGoodsTableList[0].model : ''}`
              console.log(this.turnGoodsTableList[0].RowStr, Str)
              if (this.turnGoodsTableList[0].isEnable == jsonRes.isEnable) {
                if ((this.turnGoodsTableList[0].isEnable == 1 && Str == this.turnGoodsTableList[0].RowStr) ||
                    this.turnGoodsTableList[0].isEnable == 2) {
                  JfgetCustomerAvailableNumber({
                    primaryCustomerTaxId: row.primaryCustomerTaxId,
                    customerTaxId: row.customerTaxId,
                    productType: row.productType,
                    steelMillName: row.steelMillName,
                    model: row.model,
                    specification: row.specification,
                    productTypeName: row.productTypeName
                  })
                    .then(res => {
                      row.stockAvailableNumber = res
                      this.$set(row, 'changeNumber', '')
                      this.$set(row, 'changeWeight', '')
                      this.$set(row, 'isYuanZhuanFlag', true)
                      getWeighingMethodList({
                        productType: row.productType
                      })
                        .then(res => {
                          console.log(res)
                          if (res.length > 0) row.outWeighingMethod = res[0].outWeighingMethod
                          row.RowStr = row.isEnable == 2 ? '不控货'
                            : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}${jsonRes.specificationName ? jsonRes.specificationName : ''}${jsonRes.materialName ? jsonRes.materialName : ''}` ==
                              '' ? '总控'
                              : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`

                          this.turnGoodsTableList.push(row)
                        })
                        .catch(err => {
                          this.$message({
                            message: err.message,
                            type: 'error'
                          })
                        })
                    })
                    .catch(err => {
                      this.$message({
                        message: err.message,
                        type: 'error'
                      })
                    })
                } else {
                  this.$message({
                    message: '控货类型不同，不可选择',
                    type: 'error'
                  })
                }
              } else {
                this.$message({
                  message: '控货类型不同，不可选择',
                  type: 'error'
                })
              }
            }
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }

      // this.surplusControlWeights(row.primaryCustomerTaxId, row.customerTaxId)
    }),
    isYuZhuanShow (row) {
      const that = this
      this.turnGoodsTableList.forEach((item1, index) => {
        let a = row.stockCustomerId == item1.stockCustomerId
        that.$set(row, 'isYuanZhuanFlag', a)
        // row.isYuanZhuanFlag = a
      })
    },
    delClick (index, row) {
      this.turnGoodsTableList.splice(index, 1)
      const that = this
      if (this.turnGoodsTableList.length == 0) {
        this.tableData.map(function (item) {
          that.$set(item, 'isYuanZhuanFlag', false)
          // item.isYuanZhuanFlag = false
        })
      } else {
        this.isYuZhuanShow(row)
      }

      this.changeAllWeight = parseFloat(Number(this.changeAllWeight / 1 - row.changeWeight / 1).toFixed(6))
    },
    preSelectList () {
      if (this.turnGoodsTableList.length == 0) {
        this.$message({
          message: '请先选择货物',
          type: 'error'
        })
        return
      }
      this.danjiaList = this.turnGoodsTableList
      console.log(this.danjiaList, 'this.danjiaList')
      this.turnMark = true
    },
    // 选中
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.stockCustomerId) // id数组
        arry = Array.from(new Set(arry)) // 去重
      })
      console.log(arry)
      this.selectListId = arry.join(',') // 获取全部货物id
    },
    // 盘盈盘亏
    clear () {
      console.log(23)
      if (this.xuanzhongArr == null) {
        this.$message.error('请选择一条数据进行操作')
        return
      } else if (this.xuanzhongArr.number != '0') {
        DonMessage.error('您所选的数据存在件数不为0')
        return
      }

      this.$confirm('盘盈盘亏不可恢复，确定清零吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        console.log(2323)
        JfclearStockCustomer({
          stockCustomerId: this.xuanzhongArr.stockCustomerId // 主键id
        }).then((res) => {
          this.$message.success('操作成功')
          this.JfgetStockCustomerLists()
        }).catch((err) => {
          this.$message.error(err.message)
        })
      }).catch(() => {})
    },
    daoru () {
      this.daoruMark = true
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    closeDialog () {},
    clearArr () {
      this.turnGoodsTableList = []
      this.changeAllWeight = 0
      this.tableData.map(function (item) {
        item.isYuanZhuanFlag = false
      })
    },
    changeResetForm () {
      this.turnMark = false
    },
    zhuanhuoSubmit (type) {
      console.log(this.turnGoodsTableList, 'this.turnGoodsTableList')
      if (type == 'hg') {
        this.showBianhao = false
      } else {
        this.showBianhao = true
      }
      if (this.turnGoodsTableList.length == 0) {
        this.$message({
          message: '预选清单为空，请先预选',
          type: 'error'
        })
        return
      }
      this.turnform.primaryCustomerTaxId = ''
      this.turnform.customerTaxId = ''
      this.turnform.customerChangNo = ''
      let turnJian = this.turnGoodsTableList.reduce((pre, cur) => {
        return pre / 1 + cur.changeNumber / 1
      }, 0)
      console.log(type, this.changeAllWeight, this.turnGoodsTableList[0].KucunAllWeight / 1 - this.turnGoodsTableList[
        0].controlStockWeight / 1)
      for (let i = 0; i < this.turnGoodsTableList.length; i++) {
        if (this.turnGoodsTableList[i].changeNumber > this.turnGoodsTableList[i].stockAvailableNumber) {
          this.$message({
            message: '件数不能大于库存可提件数',
            type: 'error'
          })
          return
        } else if (this.turnGoodsTableList[i].changeNumber / 1 == 0) {
          this.$message({
            message: '件数不能为0',
            type: 'error'
          })
          return
        } else if (this.turnGoodsTableList[i].changeWeight / 1 == 0) {
          this.$message({
            message: '吨数不能为0',
            type: 'error'
          })
          return
        } else if (type != 'hg' && this.turnGoodsTableList[i].strictReminder == 0 && this.turnGoodsTableList[i]
          .isEnable == 1 && this.turnGoodsTableList[i].controlPiece == 1 && turnJian > this.turnGoodsTableList[0]
          .controlStockNumber) {
          this.$message({
            message: '件数不能大于未提件数',
            type: 'error'
          })
          return
        } else if (type != 'hg' && this.turnGoodsTableList[i].strictReminder == 0 && this.turnGoodsTableList[i]
          .isEnable == 1 && this.turnGoodsTableList[i].controlWeight == 1 && this.changeAllWeight > this
          .turnGoodsTableList[i].controlStockWeight) {
          this.$message({
            message: '吨数不能大于未提吨数',
            type: 'error'
          })
          return
        }
      }
      if (type != 'hg' && this.turnGoodsTableList[0].isEnable == 1 && this.turnGoodsTableList[0].controlPiece == 1 &&
          turnJian > this.turnGoodsTableList[0].controlStockNumber) {
        console.log(3333, turnJian, this.turnGoodsTableList[0].controlStockNumber)
        this.$message({
          message: '总件数不能大于未提件数',
          type: 'error'
        })
        return
      } else if (type != 'hg' && this.turnGoodsTableList[0].strictReminder == 1 && this.turnGoodsTableList[0]
        .isEnable == 1 && this.turnGoodsTableList[0].controlWeight == 1 && this.changeAllWeight > this
        .turnGoodsTableList[0].controlStockWeight) {
        this.message = '转货总重量超过未提量，是否继续转货？'
      }
      console.log(this.turnGoodsTableList, 'turnGoodsTableList')

      if (type == 'zh') {
        // this.turnZhuanhuo = true
        if ((this.turnGoodsTableList[0].isEnable == 1 && this.turnGoodsTableList[0].strictReminder == 0) || this
          .turnGoodsTableList[0].isEnable == 2 || (this.turnGoodsTableList[0].isEnable == 1 && this
          .turnGoodsTableList[0].strictReminder == 1 && this.changeAllWeight <= this.turnGoodsTableList[0]
          .controlStockWeight)) {
          this.applyVisible = true
        } else {
          this.$confirm(this.message, '提示', {
            confirmButtonText: '确定并继续',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            this.applyVisible = true
            this.isReminder = 1
          }).catch(() => {

          })
        }

        // this.trunTitle = '转货申请'
        this.trunFlag = 'zhuanhuo'
      } else if (type == 'hg') {
        console.log(type, this.changeAllWeight, this.turnGoodsTableList[0].KucunAllWeight / 1 - this
          .turnGoodsTableList[0].controlStockWeight / 1)
        if (this.turnGoodsTableList[0].controlPiece == 1 && turnJian > this.turnGoodsTableList[0].KucunAllNumber / 1 -
            this.turnGoodsTableList[0].controlStockNumber / 1) {
          console.log(2222)
          this.$message({
            message: '件数不能大于可回购件数',
            type: 'error'
          })
          return
          // 转货量<=可回购量（库存吨数-未提吨数）
        } else if (this.changeAllWeight > (this.turnGoodsTableList[0].KucunAllWeight / 1 - (this.turnGoodsTableList[0]
          .controlStockWeight / 1 > 0 ? this.turnGoodsTableList[0].controlStockWeight / 1 : 0)).toFixed(3)) {
          this.$message({
            message: '吨数不能大于可回购吨数',
            type: 'error'
          })
          return
        }
        this.turnZhuanhuo = true
        // if ((this.turnGoodsTableList[0].isEnable == 1 && this.turnGoodsTableList[0].strictReminder == 0) || this.turnGoodsTableList[0].isEnable == 2) {
        //   this.turnZhuanhuo = true
        // } else {
        //   this.ReminderVisible = true
        // }

        this.trunTitle = '回购转货申请'
        this.trunFlag = 'huigou'
        this.turnform.primaryCustomerTaxId = this.turnGoodsTableList[0].primaryCustomerTaxId
      } else if (type == 'gczh') {
        this.turnZhuanhuo = true
        // if ((this.turnGoodsTableList[0].isEnable == 1 && this.turnGoodsTableList[0].strictReminder == 0) || this.turnGoodsTableList[0].isEnable == 2) {
        //   this.turnZhuanhuo = true
        // } else {
        //   this.ReminderVisible = true
        // }

        this.trunTitle = '钢厂转货申请'
        this.trunFlag = 'gangchang'
      }
    },

    zhuanhuoSave () {
      let newPrimaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.turnform
        .primaryCustomerTaxId)[0].custerName
      let newSecondaryCustomerName = this.RKData.filter(item => item.taxpayerNumber == this.turnform.customerTaxId)[0]
        .custerName
      let changeType = this.trunFlag == 'zhuanhuo' ? 1 : this.trunFlag == 'huigou' ? 2 : 3
      this.ZhuanhuoLoading = true
      console.log(this.turnGoodsTableList[0])
      let obj
      let arrs = this.turnGoodsTableList[0].RowStr.split('|')
      console.log(arrs)
      if (arrs.length == 4) {
        obj = {
          primaryCustomerTaxId: this.turnGoodsTableList[0].primaryCustomerTaxId,
          customerTaxId: this.turnGoodsTableList[0].customerTaxId,
          steelMillName: arrs[0],
          productType: arrs[1],
          specification: arrs[2],
          model: arrs[3]
        }
      }
      console.log(obj)
      JfaddEmptyChangeExp({
        newPrimaryCustomerName: newPrimaryCustomerName,
        newPrimaryCustomerId: this.turnform.primaryCustomerTaxId,
        newSecondaryCustomerName: newSecondaryCustomerName,
        newSecondaryCustomerId: this.turnform.customerTaxId,
        oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
        oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
        oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
        oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
        changeType: changeType,
        cargoControlKey: this.turnGoodsTableList[0].RowStr,
        changeDetailList: this.turnGoodsTableList,
        customerChangNo: this.turnform.customerChangNo,
        isReminder: this.isReminder,
        ...obj
      })
        .then(res => {
          console.log(res)
          this.$message({
            message: '转货成功',
            type: 'success'
          })
          this.turnZhuanhuo = false
          this.turnMark = false
          this.ZhuanhuoLoading = false
          this.turnGoodsTableList = []
          this.changeAllWeight = 0
          this.JfgetStockCustomerLists()
        })
        .catch(err => {
          this.ZhuanhuoLoading = false
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    numContro (value, row) {
      console.log(value, row)
      let val = (value && value.split('')) || []
      if (val != 0) {
        console.log(row.changeNumber, 'value')
        row.changeNumber = val.join('').match(/^\d*(\.?\d{0,1})/g)[0] || null
        // this.changeNumber = row.changeNumber
        row.changeWeight = parseFloat((row.singletonWeight / 1 * row.changeNumber / 1).toFixed(6))
        this.changeAllWeight = parseFloat(this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1,
          0)
          .toFixed(6))

        // this.turnGoodsTableList[0]['changeWeight'] = (row.singletonWeight * this.changeNumber).toFixed(4)
      } else {
        row.changeNumber = ''
        row.changeWeight = ''
        this.changeAllWeight = parseFloat(this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1,
          0)
          .toFixed(6))
        // this.turnGoodsTableList[0]['changeWeight'] = ''
      }
    },
    numControB (value, row) {
      let val = (value && value.split('')) || []
      row.changeWeight = val.join('').match(/^\d*(\.?\d{0,3})/g)[0] || null
      console.log(row.changeWeight, 'row.changeWeight')
      this.changeAllWeight = parseFloat(this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1,
        0).toFixed(6))
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsStockName + '/stockThreadExp/exportStockCustomerList',
        this.formData,
        '客户库存信息表'
      )
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    zhuanhuoDialogclose () {
      this.ZhuanhuoLoading = false
      this.turnZhuanhuo = false
    },
    ReminderCancel () {
      this.ReminderVisible = false
    },
    ReminderOk () {
      this.ReminderVisible = false
      this.turnZhuanhuo = true
      this.isReminder = 1
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location =
          'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/wms/%E5%AE%A2%E6%88%B7%E5%BA%93%E5%AD%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls'
      // 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/wms/%E5%AE%A2%E6%88%B7%E5%BA%93%E5%AD%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx' // 后更改页面地址
    }
  }

}

</script>

<style lang='less' scoped>
  .messages {
    font-size: 16px;
  }
  .formBox /deep/ .el-form-item{
  margin-bottom: 0px!important;
}

</style>
